"use client"
//logica scanner web npms
//npm install @zxing/library @zxing/browser
import { useState, useEffect, useContext } from "react"
import { DataGrid } from "@mui/x-data-grid"
import Paper from "@mui/material/Paper"
import EditIcon from "@mui/icons-material/Edit"
import CloseIcon from "@mui/icons-material/Close"
import WarningIcon from "@mui/icons-material/Warning"
import InventoryIcon from "@mui/icons-material/Inventory"
import DeleteIcon from "@mui/icons-material/Delete" // Importando icono de eliminar
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline"
import CreateItemComponent from "./CreateItemComponent.js"
import { ErpContext } from "../../context/ErpContext.js"
// CreateItemComponentModal ya no se usa - ahora CreateItemComponent maneja crear y editar
import CustomPagination from "../transaccionComponent/CustomPagination.js"
import BuscadorItemsUbicaciones from "./BuscadorItemsUbicaciones.js"
import SpinnerLading from "../misc/SpinnerComponent.js"
import GestionGenerarCompraComponent from "../transaccionComponent/GestionGenerarCompraComponent.js"
import LocationOnIcon from "@mui/icons-material/LocationOn"
import CalendarTodayIcon from "@mui/icons-material/CalendarToday"
import PersonIcon from "@mui/icons-material/Person"
import FileDownloadIcon from "@mui/icons-material/FileDownload"
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered"
import NewReleasesIcon from "@mui/icons-material/NewReleases"
import FilterAltIcon from "@mui/icons-material/FilterAlt"
import SearchIcon from "@mui/icons-material/Search"
import ClearIcon from "@mui/icons-material/Clear"

import {
  IconButton,
  Modal,
  Box,
  Button,
  Typography,
  Chip,
  Tooltip,
  alpha,
  useTheme,
  Checkbox,
  Drawer,
  Divider,
  TextField,
  InputAdornment,
  Badge,
} from "@mui/material"

export default function InventarioComponent() {
  const theme = useTheme()
  const FILTER_PANEL_WIDTH = 92
  const DATA_GRID_MIN_WIDTH = 1100

  const {
    getItemAndItemUbicacion,
    getUbicacion,
    getDeletedItemUbicacion,
    itemAtributoNoEliminados,
    getItemAtributoNoEliminados,
    isNavbarCollapsed,
    getParametrosGlobales,
    exportarPLUsBalanza,
    bulkDeleteItems,
    getBomByIdItem,
    contarPasajerosLiberados,
    getVendedorPaquete,
    getItemUbicacionStatsBatch,
  } = useContext(ErpContext)

  const [itemEditable, setItemEditable] = useState(null)
  const [openModal, setOpenModal] = useState(false) // Modal de edición
  const [openCreateItemModal, setOpenCreateItemModal] = useState(false) // Modal con /crearItem
  const [alignment, setAlignment] = useState("inventario")
  const [loading, setLoading] = useState(true)
  const [page, setPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  const [totalCount, setTotalCount] = useState(0)
  const [itemAndItemUbicacion, setItemAndItemUbicacion] = useState([])
  const [filters, setFilters] = useState({})
  const [selectedItems, setSelectedItems] = useState([])
  const [selectAll, setSelectAll] = useState(false)
  const [openCompraModal, setOpenCompraModal] = useState(false)
  const [compraData, setCompraData] = useState(null)
  const [parametrosGlobales, setParametrosGlobales] = useState({})
  const [ubicacionSeleccionada, setUbicacionSeleccionada] = useState(null)
  const [soloItemsConPLU, setSoloItemsConPLU] = useState(false)

  const [filtroUltimosCreados, setFiltroUltimosCreados] = useState(false)
  const [filtroStockBajo, setFiltroStockBajo] = useState(false)

  const [mostrarFiltroAtributos, setMostrarFiltroAtributos] = useState(false)
  const [mostrarFiltroPLU, setMostrarFiltroPLU] = useState(false)
  const [filtrosAtributos, setFiltrosAtributos] = useState({})

  const [modoEliminacion, setModoEliminacion] = useState(false)
  const [itemsSeleccionadosParaEliminar, setItemsSeleccionadosParaEliminar] = useState([])
  const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false)

  const showPluExport = parametrosGlobales?.pluBalanza === "1"

  const hayFiltroUbicacion = !!filters.ubicacionId
  const tipoEliminacion = hayFiltroUbicacion ? "itemUbicacion" : "itemCompleto"

  const attributeLabels = itemAtributoNoEliminados
    .filter((attr) => !attr.eliminado)
    .reduce((acc, attr, index) => {
      acc[`itemDatoAtributo${index + 1}`] = attr.descripcion
      return acc
    }, {})

  const formatCurrency = (value) => {
    if (typeof value !== "number") return "Sin información"
    return value.toLocaleString("es-AR", { style: "currency", currency: "ARS" })
  }
  useEffect(() => {
    setLoading(false)
  }, [itemAndItemUbicacion])

  useEffect(() => {
    if (itemAndItemUbicacion.length === 0) {
      setSelectedItems([])
      setSelectAll(false)
      setItemsSeleccionadosParaEliminar([]) // Limpiar selección de eliminación si no hay items
      setModoEliminacion(false) // Desactivar modo eliminación si no hay items
    }
  }, [itemAndItemUbicacion])

  useEffect(() => {
    const cargarParametrosGlobales = async () => {
      try {
        const parametros = await getParametrosGlobales(["pluBalanza", "fabricanteBalanza"])
        setParametrosGlobales(parametros)
      } catch (error) {
        console.error("Error al cargar parámetros globales:", error)
      }
    }

    cargarParametrosGlobales()
  }, [getParametrosGlobales])

  const handleExportarPLUsBalanza = async () => {
    if (!ubicacionSeleccionada) {
      alert("Debe seleccionar una ubicación antes de exportar")
      return
    }

    try {
      await exportarPLUsBalanza(ubicacionSeleccionada)
    } catch (error) {
      console.error("Error al exportar PLUs de balanza:", error)
      alert("Error al exportar PLUs de balanza: " + error.message)
    }
  }

  const isExportButtonEnabled = () => {
    return parametrosGlobales?.pluBalanza === "1" && parametrosGlobales?.fabricanteBalanza && ubicacionSeleccionada
  }

  const handleToggleFiltroUltimosCreados = () => {
    const newValue = !filtroUltimosCreados
    setFiltroUltimosCreados(newValue)
    setFilters((prev) => ({ ...prev, mostrarUltimosCreados: newValue }))
    setPage(1)
  }

  const handleToggleFiltroStockBajo = () => {
    const newValue = !filtroStockBajo
    setFiltroStockBajo(newValue)
    setFilters((prev) => ({ ...prev, soloStockBajo: newValue }))
    setPage(1)
  }

  const handleToggleFiltroPLU = () => {
    const newValue = !soloItemsConPLU
    setSoloItemsConPLU(newValue)
    setFilters((prev) => ({ ...prev, soloItemsConPLU: newValue }))
    setPage(1)
  }

  const mapearAtributosACampos = () => {
    return itemAtributoNoEliminados
      .filter((attr) => !attr.eliminado)
      .map((attr, index) => ({
        id: attr.id,
        descripcion: attr.descripcion,
        campo: `itemDatoAtributo${index + 1}`,
        index: index + 1,
      }))
  }

  const handleAtributoFilterChange = (campo, valor) => {
    setFiltrosAtributos((prev) => ({
      ...prev,
      [campo]: valor,
    }))
  }

  const handleAplicarFiltrosAtributos = () => {
    fetchData(
      filters.ubicacionId,
      filters.itemId,
      filters.precio,
      filters.soloStockBajo,
      filters.mostrarUltimosCreados,
      filters.mostrarRecetas,
      filters.proveedorId,
      filters.searchText,
      !!filters.soloItemsConPLU,
      filtrosAtributos,
    )
  }

  const handleAtributoKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault()
      handleAplicarFiltrosAtributos()
    }
  }

  const handleLimpiarFiltrosAtributos = () => {
    setFiltrosAtributos({})
    fetchData(
      filters.ubicacionId,
      filters.itemId,
      filters.precio,
      filters.soloStockBajo,
      filters.mostrarUltimosCreados,
      filters.mostrarRecetas,
      filters.proveedorId,
      filters.searchText,
      !!filters.soloItemsConPLU,
      {},
    )
  }

  const cantidadFiltrosAtributosActivos = Object.values(filtrosAtributos).filter(
    (valor) => valor && valor.trim() !== "",
  ).length

  const deleteCheckboxColumn = modoEliminacion
    ? [
        {
          field: "selectDelete",
          headerName: "Eliminar",
          width: 90,
          headerAlign: "center",
          sortable: false,
          renderHeader: () => (
            <Checkbox
              checked={
                itemsSeleccionadosParaEliminar.length === itemAndItemUbicacion.length && itemAndItemUbicacion.length > 0
              }
              indeterminate={
                itemsSeleccionadosParaEliminar.length > 0 &&
                itemsSeleccionadosParaEliminar.length < itemAndItemUbicacion.length
              }
              onChange={(e) => handleSelectAllForDelete(e.target.checked)}
              size="small"
              color="error"
            />
          ),
          renderCell: (params) => (
            <Checkbox
              checked={itemsSeleccionadosParaEliminar.includes(params.row.idItem)}
              onChange={(e) => handleSelectItemForDelete(params.row.idItem, e.target.checked)}
              size="small"
              color="error"
            />
          ),
        },
      ]
    : []

  const staticColumnsBefore = [
    {
      field: "createdAt",
      headerName: "Fecha",
      width: 180,
      headerAlign: "center",
      align: "right",
    },
    {
      field: "codigo",
      headerName: "Grupo",
      headerAlign: "center",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => (
        <Box sx={{ display: "flex", alignItems: "center", width: "100%", justifyContent: "flex-start" }}>
          <Chip
            label={params.value}
            size="small"
            variant="outlined"
            sx={{
              fontWeight: 500,
              borderColor: "rgb(244, 147, 14)",
              color: "rgb(244, 147, 14)",
              borderRadius: 1,
              borderWidth: 1,
            }}
          />
        </Box>
      ),
    },
    {
      field: "descripcion",
      headerName: "Descripción",
      width: 300,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <Tooltip title={params.value} arrow>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <InventoryIcon fontSize="small" sx={{ color: alpha("#5b5b5f", 0.7) }} />
            <Typography
              variant="body2"
              sx={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {params.value}
            </Typography>
          </Box>
        </Tooltip>
      ),
    },
  ]

  const staticColumnsAfter = [
    {
      field: "ubicacion",
      headerName: "Destino",
      width: 130,
      headerAlign: "center",
      align: "right",
      renderCell: (params) => (
        <Box sx={{ display: "flex", alignItems: "right", gap: 1 }}>
          <LocationOnIcon fontSize="small" sx={{ color: alpha("#5b5b5f", 0.7) }} />
          <Typography variant="body2">{params.value}</Typography>
        </Box>
      ),
    },
    {
      field: "vendedor",
      headerName: "Vendedor",
      width: 150,
      headerAlign: "center",
      align: "right",
      renderCell: (params) => (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <PersonIcon fontSize="small" sx={{ color: alpha("#5b5b5f", 0.7) }} />
          <Typography variant="body2">{params.value || "-"}</Typography>
        </Box>
      ),
    },
    {
      field: "fechaViaje",
      headerName: "Fecha Viaje",
      width: 130,
      headerAlign: "center",
      align: "right",
      renderCell: (params) => (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {/* <CalendarTodayIcon fontSize="small" sx={{ color: alpha("#5b5b5f", 0.7) }} /> */}
          <Typography variant="body2">{params.value || "-"}</Typography>
        </Box>
      ),
    },
    {
      field: "inventario",
      headerName: "Pasajeros",
      width: 150,
      headerAlign: "center",
      align: "right",
      renderCell: (params) => (
        <Chip
          label={params.value}
          size="small"
          color="warning"
          sx={{
            fontWeight: "bold",
            backgroundColor: alpha("#3182ce", 0.1),
            color: "#3182ce",
            border: `1px solid ${alpha("#3182ce", 0.3)}`,
          }}
        />
      ),
    },
    {
      field: "pasajerosAbonados",
      headerName: "Abonados",
      width: 160,
      headerAlign: "center",
      align: "right",
      renderCell: (params) => (
        <Chip
          label={params.value || 0}
          size="small"
          sx={{
            fontWeight: "bold",
            backgroundColor: alpha("#4CAF50", 0.1),
            color: "#4CAF50",
            border: `1px solid ${alpha("#4CAF50", 0.3)}`,
          }}
        />
      ),
    },
    {
      field: "pasajerosNoAbonados",
      headerName: "No Abonados",
      width: 180,
      headerAlign: "center",
      align: "right",
      renderCell: (params) => (
        <Chip
          label={params.value || 0}
          size="small"
          sx={{
            fontWeight: "bold",
            backgroundColor: alpha("#f44336", 0.1),
            color: "#f44336",
            border: `1px solid ${alpha("#f44336", 0.3)}`,
          }}
        />
      ),
    },
    {
      field: "pasajerosLiberados",
      headerName: "Liberados",
      width: 150,
      headerAlign: "center",
      align: "right",
      renderCell: (params) => (
        <Chip
          label={params.value || 0}
          size="small"
          sx={{
            fontWeight: "bold",
            backgroundColor: alpha("#4CAF50", 0.1),
            color: "#4CAF50",
            border: `1px solid ${alpha("#4CAF50", 0.3)}`,
          }}
        />
      ),
    },
    {
      field: "alertaPorcentaje",
      headerName: "Alerta %",
      width: 130,
      headerAlign: "center",
      align: "right",
      renderCell: (params) => {
        const valor = params.value
        const porcentaje = valor !== null && valor !== undefined 
          ? `${(valor * 100).toFixed(1)}%` 
          : "N/A"
        
        // Color según el porcentaje: verde si es alto, amarillo medio, rojo si es bajo
        let color = "#4CAF50" // Verde por defecto
        if (valor !== null && valor !== undefined) {
          if (valor < 0.3) {
            color = "#f44336" // Rojo si es menor a 30%
          } else if (valor < 0.6) {
            color = "#ff9800" // Naranja si está entre 30% y 60%
          } else {
            color = "#4CAF50" // Verde si es mayor a 60%
          }
        }
        
        return (
          <Chip
            label={porcentaje}
            size="small"
            sx={{
              fontWeight: "bold",
              backgroundColor: alpha(color, 0.1),
              color: color,
              border: `1px solid ${alpha(color, 0.3)}`,
            }}
          />
        )
      },
    },
    {
      field: "precioClienteGenerico",
      headerName: "Precio",
      width: 130,
      headerAlign: "center",
      align: "right",
      renderCell: (params) => (
        <Chip
          label={params.value ? `$${params.value.toLocaleString("es-AR")}` : "N/A"}
          size="small"
          variant="outlined"
          sx={{
            fontWeight: 500,
            borderColor: params.value ? "rgb(76, 175, 80)" : "rgb(158, 158, 158)",
            color: params.value ? "rgb(76, 175, 80)" : "rgb(158, 158, 158)",
          }}
        />
      ),
    },
    {
      field: "updatedAt",
      headerName: "Última Actualización",
      width: 180,
      headerAlign: "center",
      align: "right",
    },
    {
      field: "action",
      headerName: "Acciones",
      width: 100,
      headerAlign: "center",
      align: "right",
      renderCell: (params) => (
        <IconButton
          className="colorGeneralParaIconos"
          onClick={() => {
            setItemEditable(params.row)
            setOpenModal(true)
          }}
          sx={{
            color: theme.palette.primary.main,
            "&:hover": {
              backgroundColor: alpha(theme.palette.primary.main, 0.2),
            },
            transition: "background-color 0.2s",
          }}
        >
          <EditIcon fontSize="small" />
        </IconButton>
      ),
    },
    ...(filters.proveedorId
      ? [
          {
            field: "select",
            headerName: "Comprar",
            width: 100,
            headerAlign: "center",
            sortable: false,
            renderHeader: () => (
              <Checkbox checked={selectAll} onChange={(e) => handleSelectAll(e.target.checked)} size="small" />
            ),
            renderCell: (params) => (
              <Checkbox
                checked={selectedItems.includes(params.row.id)}
                onChange={(e) => handleSelectItem(params.row.id, e.target.checked)}
                size="small"
              />
            ),
          },
        ]
      : []),
  ]

  const dynamicColumns = itemAtributoNoEliminados
    .filter((attr) => !attr.eliminado)
    .map((attr) => ({
      field: `itemDatoAtributo${attr.id}`,
      headerName: attr.descripcion,
      width: 150,
      headerAlign: "center",
      align: "right",
      renderCell: (params) => (
        <Typography variant="body2">
          {params.row.activeAttributes ? params.row.activeAttributes[`itemDatoAtributo${attr.id}`] || "-" : "-"}
        </Typography>
      ),
    }))

  const precioProveedorColumn = filters.proveedorId
    ? [
        {
          field: "precioProveedor",
          headerName: "Precio Proveedor",
          width: 130,
          headerAlign: "center",
          align: "right",
          renderCell: (params) => (
            <Chip
              label={params.value ? `$${params.value.toLocaleString("es-AR")}` : "N/A"}
              size="small"
              variant="outlined"
              sx={{
                fontWeight: 500,
                borderColor: params.value ? "rgb(76, 175, 80)" : "rgb(158, 158, 158)",
                color: params.value ? "rgb(76, 175, 80)" : "rgb(158, 158, 158)",
              }}
            />
          ),
        },
      ]
    : []

  const columns = [
    ...deleteCheckboxColumn,
    ...staticColumnsBefore,
    ...dynamicColumns,
    ...precioProveedorColumn,
    ...staticColumnsAfter,
  ]

  // Estadísticas por lote: se calculan en backend con un solo request

  const fetchData = async (
    ubicacionId,
    itemId,
    precio,
    soloStockBajo,
    mostrarUltimosCreados,
    mostrarRecetas,
    proveedorId,
    searchText = null,
    soloConPLU = false,
    atributosFilters = {},
  ) => {
    try {
      await getItemAtributoNoEliminados()
      const data = await getItemAndItemUbicacion(
        page,
        100,
        ubicacionId,
        itemId,
        precio,
        soloStockBajo,
        mostrarUltimosCreados,
        mostrarRecetas,
        proveedorId,
        searchText,
        soloConPLU,
        atributosFilters,
      )
      if (data) {
        const pairs = data.data.map((r) => ({ idItem: r.idItem, idUbicacion: r.idUbicacion }))
        const statsMap = await getItemUbicacionStatsBatch(pairs)

        const dataWithAllInfo = data.data.map((row) => {
          const key = `${row.idItem}-${row.idUbicacion}`
          const stats = statsMap[key] || {}
          let fechaViajeFmt = null
          if (stats.fechaViaje) {
            const d = new Date(stats.fechaViaje)
            fechaViajeFmt = new Intl.DateTimeFormat("es-AR", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            }).format(d)
          }
          // Calcular Alerta %: pasajerosAbonados / (inventario - pasajerosLiberados)
          const cantidadPasajeros = row.inventario || 0
          const pasajerosLiberados = stats.pasajerosLiberados || 0
          const pasajerosAbonados = stats.pasajerosAbonados || 0
          const denominador = cantidadPasajeros - pasajerosLiberados
          
          let alertaPorcentaje = null
          if (denominador > 0) {
            alertaPorcentaje = pasajerosAbonados / denominador
          } else if (cantidadPasajeros === 0) {
            // Si no hay pasajeros, no hay porcentaje
            alertaPorcentaje = null
          } else {
            // Si todos los pasajeros están liberados, el porcentaje es 0
            alertaPorcentaje = 0
          }
          
          return {
            ...row,
            fechaViaje: fechaViajeFmt,
            pasajerosLiberados: pasajerosLiberados,
            vendedor: stats.vendedor || null,
            pasajerosAbonados: pasajerosAbonados,
            pasajerosNoAbonados: stats.pasajerosNoAbonados || 0,
            alertaPorcentaje: alertaPorcentaje,
          }
        })

        setItemAndItemUbicacion(dataWithAllInfo)
        setTotalPages(data.totalPages)
        setTotalCount(data.total)
      }
    } catch (error) {
      console.error("Error fetching inventory data:", error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    const hasActiveFilters =
      Object.keys(filters).length > 0 &&
      Object.values(filters).some((value) => value !== null && value !== false && value !== "")

    if (hasActiveFilters) {
      fetchData(
        filters.ubicacionId,
        filters.itemId,
        filters.precio,
        filters.soloStockBajo,
        filters.mostrarUltimosCreados,
        filters.mostrarRecetas,
        filters.proveedorId,
        filters.searchText,
        !!filters.soloItemsConPLU,
        filtrosAtributos,
      )
    } else {
      fetchData(null, null, null, null, null, null, null, null, false, filtrosAtributos)
    }
  }, [page, alignment, filters])

  const handleChange = (_, newAlignment) => {
    if (newAlignment) setAlignment(newAlignment)
  }

  const handleOpenModal = async (transaccionRow) => {
    console.log(transaccionRow)
    setItemEditable(transaccionRow)
    setOpenModal(true)
  }

  const handleOpenCreateItemModal = () => {
    setOpenCreateItemModal(true)
  }

  const handleCloseModal = () => {
    setOpenModal(false)
    setItemEditable(null)
    fetchData(
      filters.ubicacionId,
      filters.itemId,
      filters.precio,
      filters.soloStockBajo,
      filters.mostrarUltimosCreados,
      filters.mostrarRecetas,
      filters.proveedorId,
      filters.searchText,
      !!filters.soloItemsConPLU,
      filtrosAtributos,
    )
  }

  const handleCloseCreateItemModal = () => {
    setOpenCreateItemModal(false)
    fetchData(
      filters.ubicacionId,
      filters.itemId,
      filters.precio,
      filters.soloStockBajo,
      filters.mostrarUltimosCreados,
      filters.mostrarRecetas,
      filters.proveedorId,
      filters.searchText,
      !!filters.soloItemsConPLU,
      filtrosAtributos,
    )
  }

  const handleFilterSearch = (newFilters) => {
    setFilters((prev) => ({
      ...prev,
      ...newFilters,
      soloItemsConPLU:
        typeof newFilters.soloItemsConPLU === "boolean" ? newFilters.soloItemsConPLU : prev.soloItemsConPLU,
    }))
    setPage(1)
    setSelectedItems([])
    setSelectAll(false)
    setUbicacionSeleccionada(newFilters.ubicacionId || null)
    if (typeof newFilters.soloItemsConPLU === "boolean") {
      setSoloItemsConPLU(newFilters.soloItemsConPLU)
    }
    setItemsSeleccionadosParaEliminar([])
    setModoEliminacion(false)
  }

  const handleAlignmentChange = (_, newAlignment) => {
    if (newAlignment) setAlignment(newAlignment)
  }

  const handleRefresh = () => {
    setFilters({})
    setPage(1)
    setSelectedItems([])
    setSelectAll(false)
    setFiltrosAtributos({})
    setFiltroUltimosCreados(false)
    setFiltroStockBajo(false)
    setSoloItemsConPLU(false)
    setModoEliminacion(false)
    setItemsSeleccionadosParaEliminar([])
    fetchData(null, null, null, null, null, null, null, null, false, {})
  }

  const handleSelectItem = (itemId, isSelected) => {
    if (isSelected) {
      setSelectedItems((prev) => [...prev, itemId])
      if (selectedItems.length + 1 === itemAndItemUbicacion.length) {
        setSelectAll(true)
      }
    } else {
      setSelectedItems((prev) => prev.filter((id) => id !== itemId))
      setSelectAll(false)
    }
  }

  const handleSelectAll = (isSelected) => {
    if (isSelected) {
      const allItemIds = itemAndItemUbicacion.map((item) => item.id)
      setSelectedItems(allItemIds)
      setSelectAll(true)
    } else {
      setSelectedItems([])
      setSelectAll(false)
    }
  }

  const handleGenerateCompra = () => {
    const selectedItemsData = itemAndItemUbicacion.filter((item) => selectedItems.includes(item.id))

    const dataForCompra = {
      selectedItems: selectedItemsData,
      proveedor: filters.proveedorId
        ? {
            id: filters.proveedorId,
          }
        : null,
      ubicacion: filters.ubicacionId
        ? {
            id: filters.ubicacionId,
          }
        : null,
    }

    console.log("Abriendo modal de compra con datos:", dataForCompra)

    setCompraData(dataForCompra)
    setOpenCompraModal(true)
  }

  const handleCloseCompraModal = () => {
    setOpenCompraModal(false)
    setCompraData(null)
    setSelectedItems([])
    setSelectAll(false)
  }

  const handleSelectItemForDelete = (itemId, isSelected) => {
    if (isSelected) {
      setItemsSeleccionadosParaEliminar((prev) => [...prev, itemId])
    } else {
      setItemsSeleccionadosParaEliminar((prev) => prev.filter((id) => id !== itemId))
    }
  }

  const handleSelectAllForDelete = (isSelected) => {
    if (isSelected) {
      const allItemIds = itemAndItemUbicacion.map((item) => item.idItem) // Usar idItem para la selección masiva
      setItemsSeleccionadosParaEliminar(allItemIds)
    } else {
      setItemsSeleccionadosParaEliminar([])
    }
  }

  const handleOpenDeleteModal = () => {
    if (itemsSeleccionadosParaEliminar.length === 0) {
      alert("Debe seleccionar al menos un item para eliminar")
      return
    }
    setOpenConfirmDeleteModal(true)
  }

  const handleConfirmDelete = async () => {
    try {
      setLoading(true)

      const result = await bulkDeleteItems(
        itemsSeleccionadosParaEliminar,
        filters.ubicacionId || null, // Pasar ubicacionId para eliminación específica
      )

      console.log("✅ Eliminación exitosa:", result)

      setOpenConfirmDeleteModal(false)
      setItemsSeleccionadosParaEliminar([])
      setModoEliminacion(false)

      await fetchData(
        filters.ubicacionId,
        filters.itemId,
        filters.precio,
        filters.soloStockBajo,
        filters.mostrarUltimosCreados,
        filters.mostrarRecetas,
        filters.proveedorId,
        filters.searchText,
        !!filters.soloItemsConPLU,
        filtrosAtributos,
      )

      alert(`✅ Se eliminaron ${result.eliminados || itemsSeleccionadosParaEliminar.length} item(s) exitosamente`)
    } catch (error) {
      console.error("❌ Error al eliminar items:", error)
      alert("Error al eliminar items: " + (error.response?.data?.message || error.message))
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
    return <SpinnerLading />
  }

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          width: "100%",
          overflow: "hidden",
          position: "relative",
          backgroundColor: "#f8f9fa",
          padding: "2px 20px 5px 25px",
          paddingRight: 12,
          minWidth: 0,
          gap: "16px",
          // marginTop: "5px",
          "&::-webkit-scrollbar": {
            display: "none",
          },
          scrollbarWidth: "none", // Firefox
          msOverflowStyle: "none", // IE and Edge
        }}
      >
        <Box
          sx={{
            flexShrink: 0,
            backgroundColor: "#f5f5f5",
            boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
            borderRadius: "8px 8px 0 0",
          }}
        >
          {/* Filtros básicos */}
          <Box sx={{ p: 2 }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                alignItems: { xs: "stretch", md: "center" },
                gap: 2,
              }}
            >
              <Box sx={{ flex: 1 }}>
                <BuscadorItemsUbicaciones
                  onSearch={handleFilterSearch}
                  vieneDe="inventario"
                />
              </Box>

              <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                <Tooltip title="Crear nuevo grupo">
                  <Button
                    variant="contained"
                    startIcon={<AddCircleOutlineIcon />}
                    onClick={handleOpenCreateItemModal}
                    sx={{
                      textTransform: "none",
                      borderRadius: 2,
                      boxShadow: 2,
                      backgroundColor: "#5b5b5f",
                      "&:hover": {
                        backgroundColor: alpha("#5b5b5f", 0.8),
                      },
                    }}
                  >
                    Crear Grupo
                  </Button>
                </Tooltip>
              </Box>
            </Box>
          </Box>

          {(mostrarFiltroAtributos || mostrarFiltroPLU) && (
            <Box
              sx={{
                p: 2,
                pt: 0,
                display: "flex",
                flexDirection: "column",
                gap: 2,
                borderTop: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
              }}
            >
              {mostrarFiltroAtributos && itemAtributoNoEliminados && itemAtributoNoEliminados.length > 0 && (
                <Paper
                  elevation={2}
                  sx={{
                    p: 2,
                    backgroundColor: alpha(theme.palette.primary.main, 0.02),
                    border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
                  }}
                >
                  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 700, color: theme.palette.primary.main }}>
                      Filtros por Atributos
                    </Typography>
                    <IconButton size="small" onClick={() => setMostrarFiltroAtributos(false)}>
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </Box>

                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "repeat(3, 1fr)", lg: "repeat(4, 1fr)" },
                      gap: 2,
                    }}
                  >
                    {mapearAtributosACampos().map((atributo) => (
                      <TextField
                        key={atributo.campo}
                        label={atributo.descripcion}
                        size="small"
                        value={filtrosAtributos[atributo.campo] || ""}
                        onChange={(e) => handleAtributoFilterChange(atributo.campo, e.target.value)}
                        onKeyDown={handleAtributoKeyDown}
                        placeholder={`Buscar...`}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon fontSize="small" color="action" />
                            </InputAdornment>
                          ),
                          endAdornment: filtrosAtributos[atributo.campo] && (
                            <InputAdornment position="end">
                              <IconButton
                                size="small"
                                onClick={() => handleAtributoFilterChange(atributo.campo, "")}
                                edge="end"
                              >
                                <ClearIcon fontSize="small" />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            backgroundColor: filtrosAtributos[atributo.campo]
                              ? alpha(theme.palette.primary.main, 0.05)
                              : "white",
                          },
                        }}
                      />
                    ))}
                  </Box>

                  {cantidadFiltrosAtributosActivos > 0 && (
                    <Box sx={{ display: "flex", gap: 1, mt: 2, justifyContent: "flex-end" }}>
                      <Button
                        size="small"
                        variant="contained"
                        color="primary"
                        onClick={handleAplicarFiltrosAtributos}
                        sx={{ textTransform: "none" }}
                      >
                        Aplicar Filtros
                      </Button>
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={handleLimpiarFiltrosAtributos}
                        sx={{ textTransform: "none" }}
                      >
                        Limpiar
                      </Button>
                    </Box>
                  )}
                </Paper>
              )}

              {mostrarFiltroPLU && showPluExport && (
                <Paper
                  elevation={2}
                  sx={{
                    p: 2,
                    backgroundColor: alpha(theme.palette.success.main, 0.02),
                    border: `1px solid ${alpha(theme.palette.success.main, 0.2)}`,
                  }}
                >
                  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 700, color: theme.palette.success.main }}>
                      Exportar PLUs de Balanza
                    </Typography>
                    <IconButton size="small" onClick={() => setMostrarFiltroPLU(false)}>
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </Box>

                  <Box sx={{ display: "flex", flexDirection: "column", gap: 1, maxWidth: 400 }}>
                    <Button
                      onClick={handleExportarPLUsBalanza}
                      variant="contained"
                      size="medium"
                      startIcon={<FileDownloadIcon />}
                      disabled={!isExportButtonEnabled()}
                      sx={{
                        backgroundColor: isExportButtonEnabled() ? "success.main" : "grey.400",
                        color: "white",
                        textTransform: "none",
                        "&:hover": {
                          backgroundColor: isExportButtonEnabled() ? "success.dark" : "grey.400",
                        },
                      }}
                    >
                      Exportar PLUs
                    </Button>

                    {!isExportButtonEnabled() && (
                      <Typography variant="caption" color="text.secondary">
                        {!ubicacionSeleccionada
                          ? "⚠️ Seleccione una ubicación antes de exportar"
                          : !parametrosGlobales.fabricanteBalanza
                            ? "⚠️ Fabricante de balanza no configurado"
                            : "✓ Listo para exportar"}
                      </Typography>
                    )}
                  </Box>
                </Paper>
              )}
            </Box>
          )}
        </Box>

        <Drawer
          anchor="right"
          open
          hideBackdrop
          variant="persistent"
          ModalProps={{ keepMounted: true }}
          sx={{
            "& .MuiDrawer-paper": {
              width: 50,
              top: 0,
              height: "100vh",
              backgroundColor: alpha(theme.palette.background.paper, 0.98),
              borderLeft: `2px solid ${alpha(theme.palette.primary.main, 0.2)}`,
              boxShadow: "-4px 0 20px rgba(0,0,0,0.1)",
              zIndex: 1000,
              overflowX: "hidden",
            },
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column", height: "100%", p: 1 }}>
            {/* <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                mb: 2,
                pb: 1,
                borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
              }}
            >
              <Typography variant="caption" sx={{ fontWeight: 700, letterSpacing: 0.5, color: "text.secondary" }}>
                Filtros
              </Typography>
            </Box> */}

            <Box sx={{ display: "flex", flexDirection: "column", gap: 1, mb: 2 }}>
              {/* Filtrar por atributos - PRIMERO */}
              <Tooltip title="Filtrar por atributos" placement="left">
                <IconButton
                  onClick={() => setMostrarFiltroAtributos(!mostrarFiltroAtributos)}
                  sx={{
                    color: mostrarFiltroAtributos ? "rgb(244, 177, 14)" : "rgba(0, 0, 0, 0.54) !important",
                    "& svg": {
                      color: mostrarFiltroAtributos ? "rgb(244, 177, 14)" : "rgba(0, 0, 0, 0.54) !important",
                    },
                  }}
                >
                  <Badge badgeContent={cantidadFiltrosAtributosActivos} color="primary">
                    <FilterAltIcon />
                  </Badge>
                </IconButton>
              </Tooltip>

              {/* <Tooltip title="Últimos creados" placement="left">
                <IconButton
                  onClick={handleToggleFiltroUltimosCreados}
                  sx={{
                    color: filtroUltimosCreados ? "rgb(244, 177, 14)" : "rgba(0, 0, 0, 0.54) !important",
                    "& svg": {
                      color: filtroUltimosCreados ? "rgb(244, 177, 14)" : "rgba(0, 0, 0, 0.54) !important",
                    },
                  }}
                >
                  <NewReleasesIcon />
                </IconButton>
              </Tooltip> */}

              {/* OCULTO: Stock bajo */}
              {/* <Tooltip title="Stock bajo" placement="left">
                <IconButton
                  onClick={handleToggleFiltroStockBajo}
                  sx={{
                    color: filtroStockBajo ? "rgb(244, 177, 14)" : "rgba(0, 0, 0, 0.54) !important",
                    "& svg": {
                      color: filtroStockBajo ? "rgb(244, 177, 14)" : "rgba(0, 0, 0, 0.54) !important",
                    },
                  }}
                >
                  <WarningIcon />
                </IconButton>
              </Tooltip> */}

              {/* OCULTO: Solo items con PLU */}
              {/* {showPluExport && (
                <Tooltip title="Solo items con PLU" placement="left">
                  <IconButton
                    onClick={handleToggleFiltroPLU}
                    sx={{
                      color: soloItemsConPLU ? "rgb(244, 177, 14)" : "rgba(0, 0, 0, 0.54) !important",
                      "& svg": {
                        color: soloItemsConPLU ? "rgb(244, 177, 14)" : "rgba(0, 0, 0, 0.54) !important",
                      },
                    }}
                  >
                    <FormatListNumberedIcon />
                  </IconButton>
                </Tooltip>
              )} */}

              <Divider sx={{ my: 1 }} />

              <Tooltip title="Modo eliminación" placement="left">
                <IconButton
                  onClick={() => {
                    const newValue = !modoEliminacion
                    setModoEliminacion(newValue)
                    if (!newValue) {
                      setItemsSeleccionadosParaEliminar([])
                    }
                  }}
                  sx={{
                    color: modoEliminacion ? "rgb(244, 177, 14)" : "rgba(0, 0, 0, 0.54) !important",
                    "& svg": {
                      color: modoEliminacion ? "rgb(244, 177, 14)" : "rgba(0, 0, 0, 0.54) !important",
                    },
                  }}
                >
                  <DeleteIcon />
                </IconButton>
              </Tooltip>

              {/* OCULTO: Exportar PLUs balanza */}
              {/* {showPluExport && (
                <Tooltip title="Exportar PLUs balanza" placement="left">
                  <IconButton
                    onClick={() => setMostrarFiltroPLU(!mostrarFiltroPLU)}
                    sx={{
                      color: mostrarFiltroPLU ? "rgb(244, 177, 14)" : "rgba(0, 0, 0, 0.54) !important",
                      "& svg": {
                        color: mostrarFiltroPLU ? "rgb(244, 177, 14)" : "rgba(0, 0, 0, 0.54) !important",
                      },
                    }}
                  >
                    <FileDownloadIcon />
                  </IconButton>
                </Tooltip>
              )} */}
            </Box>
          </Box>
        </Drawer>

        <Box 
          sx={{ 
            flex: 1, 
            overflow: "hidden",
            position: "relative",
            minWidth: 0,
            "&::-webkit-scrollbar": {
              display: "none",
            },
            scrollbarWidth: "none", // Firefox
            msOverflowStyle: "none", // IE and Edge
          }}
        >
          <Paper
            sx={{
              height: "100%",
              width: "100%",
              boxShadow: "none",
              border: "1px solid rgba(0,0,0,0.08)",
              borderTop: "none",
              overflow: "hidden",
              overflowX: "auto",
              scrollbarWidth: "thin", // Firefox
              "&::-webkit-scrollbar": {
                height: "8px",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#888",
                borderRadius: "10px",
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "#f1f1f1",
                borderRadius: "10px",
              },
            }}
          >
            <Box sx={{ width: "100%", height: "100%", minWidth: DATA_GRID_MIN_WIDTH }}>
              <DataGrid
                key={isNavbarCollapsed ? "collapsed" : "expanded"}
                className="tablaVentasDataGrid"
                rows={itemAndItemUbicacion}
                columns={columns}
                getRowId={(row) => row.id}
                pageSizeOptions={[5, 10]}
                pagination
                getRowHeight={() => 35}
                headerHeight={35}
                paginationMode="server"
                pageSize={100}
                sx={{
                  minWidth: DATA_GRID_MIN_WIDTH,
                  width: "100%",
                  height: "100%",
                  border: 0,
                  overflow: "auto",
                  "&::-webkit-scrollbar": {
                    display: "none",
                  },
                  scrollbarWidth: "none", // Firefox
                  msOverflowStyle: "none", // IE and Edge
                  "& .MuiDataGrid-footerContainer": {
                    display: "none !important",
                  },
                  "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: "#5b5b5f",
                    color: "white",
                    borderBottom: "2px solid #333",
                    height: "45px !important",
                    minHeight: "45px !important",
                    maxHeight: "45px !important",
                  },
                  "& .MuiDataGrid-columnHeader": {
                    height: "45px !important",
                    minHeight: "45px !important",
                    maxHeight: "45px !important",
                  },
                  "& .MuiDataGrid-columnHeaderTitle": {
                    color: "white !important",
                    lineHeight: "45px !important",
                  },
                  "& .MuiDataGrid-columnHeaderTitle .MuiDataGrid-menuIconButton": {
                    color: "white !important",
                  },
                  "& .MuiDataGrid-menuIconButton": {
                    color: "rgb(244, 177, 14) !important",
                  },
                  "& .MuiInputBase-root": {
                    color: "rgb(244, 177, 14) !important",
                  },
                  "& .MuiTablePagination-root": {
                    color: "black !important",
                  },
                  "& .MuiSelect-icon": {
                    color: "rgb(244, 177, 14) !important",
                  },
                  "& .MuiDataGrid-cell": {
                    borderBottom: "1px solid #ccc",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  },
                  "& .MuiDataGrid-row": {
                    "&:nth-of-type(even)": {
                      backgroundColor: "#F7F7F7",
                    },
                    "&:hover": {
                      backgroundColor: "#E3EAFD",
                      transition: "background 0.3s ease",
                    },
                  },
                  "& .row-devolucion": {
                    backgroundColor: alpha("#9e9e9e !important", 0.05),
                    "&:hover": {
                      backgroundColor: alpha("#9e9e9e !important", 0.1),
                    },
                  },
                  "& .MuiDataGrid-virtualScroller": {
                    lineHeight: "none !important",
                    height: "100% !important",
                    maxHeight: "100% !important",
                    overflow: "auto !important",
                    "&::-webkit-scrollbar": {
                      width: "8px",
                      height: "8px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      backgroundColor: "#888",
                      borderRadius: "10px",
                    },
                    "&::-webkit-scrollbar-track": {
                      backgroundColor: "#f1f1f1",
                      borderRadius: "10px",
                    },
                  },
                  "& .MuiDataGrid-footerContainer": {
                    position: "sticky",
                    bottom: 0,
                    backgroundColor: "#ffffff",
                    borderTop: "1px solid #ddd",
                    zIndex: 10,
                  },
                }}
                components={{
                  Pagination: () => null,
                }}
              />
            </Box>
          </Paper>
        </Box>

        <Box
          sx={{
            flexShrink: 0,
            backgroundColor: "#f5f5f5",
            borderRadius: "0 0 8px 8px",
            borderTop: "1px solid rgba(0,0,0,0.08)",
            padding: "0px",
            paddingBottom: "10px",
            zIndex: 1,
          }}
        >
          <CustomPagination
            currentPage={page}
            totalPages={totalPages}
            totalCount={totalCount}
            vieneDe={"inventaryComponent"}
            onPageChange={(newPage) => setPage(newPage)}
          />
        </Box>

        {modoEliminacion && itemsSeleccionadosParaEliminar.length > 0 && (
          <Box
            sx={{
              mt: 2,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              p: 2,
              backgroundColor: alpha(theme.palette.error.main, 0.08),
              borderRadius: 2,
              border: `2px solid ${theme.palette.error.main}`,
              animation: "pulse 2s ease-in-out infinite",
              "@keyframes pulse": {
                "0%, 100%": { borderColor: theme.palette.error.main },
                "50%": { borderColor: alpha(theme.palette.error.main, 0.5) },
              },
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <DeleteIcon color="error" />
              <Box>
                <Typography variant="body1" sx={{ fontWeight: 700, color: "error.main" }}>
                  {itemsSeleccionadosParaEliminar.length} item(s) seleccionado(s) para eliminar
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {hayFiltroUbicacion
                    ? `Se eliminará solo de la ubicación filtrada`
                    : "Se eliminarán los items completos y todas sus ubicaciones"}
                </Typography>
              </Box>
            </Box>

            <Box sx={{ display: "flex", gap: 1 }}>
              <Button
                variant="outlined"
                size="small"
                color="inherit"
                onClick={() => {
                  setItemsSeleccionadosParaEliminar([])
                }}
                sx={{ textTransform: "none" }}
              >
                Cancelar
              </Button>

              <Button
                variant="contained"
                size="small"
                color="error"
                startIcon={<DeleteIcon />}
                onClick={handleOpenDeleteModal}
                sx={{
                  textTransform: "none",
                  fontWeight: 600,
                  "&:hover": {
                    backgroundColor: theme.palette.error.dark,
                  },
                }}
              >
                Eliminar ({itemsSeleccionadosParaEliminar.length})
              </Button>
            </Box>
          </Box>
        )}

        {filters.proveedorId && (
          <Box
            sx={{
              mt: 2,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              p: 2,
              backgroundColor: alpha(theme.palette.primary.main, 0.05),
              borderRadius: 2,
              border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                {selectedItems.length} items seleccionados
              </Typography>
              {selectedItems.length > 0 && (
                <Chip label={`${selectedItems.length} seleccionados`} size="small" color="primary" variant="filled" />
              )}
            </Box>

            <Box sx={{ display: "flex", gap: 1 }}>
              <Button
                variant="outlined"
                size="small"
                onClick={() => {
                  setSelectedItems([])
                  setSelectAll(false)
                }}
                disabled={selectedItems.length === 0}
                sx={{ textTransform: "none" }}
              >
                Limpiar Selección
              </Button>

              <Button
                variant="contained"
                size="small"
                onClick={handleGenerateCompra}
                disabled={selectedItems.length === 0}
                sx={{
                  textTransform: "none",
                  backgroundColor: theme.palette.success.main,
                  "&:hover": {
                    backgroundColor: theme.palette.success.dark,
                  },
                }}
              >
                Generar Compra ({selectedItems.length})
              </Button>
            </Box>
          </Box>
        )}

        {/* Modal para crear grupo usando la misma pantalla de /crearItem */}
        <Modal
          open={openCreateItemModal}
          onClose={handleCloseCreateItemModal}
          aria-labelledby="create-item-modal-title"
          aria-describedby="create-item-modal-description"
          closeAfterTransition
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              width: { xs: "97%", sm: "95%", md: "92%", lg: "90%" },
              maxWidth: "1300px",
              height: "92vh",
              bgcolor: "background.paper",
              boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
              borderRadius: "12px",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
              position: "relative",
              animation: "fadeIn 0.3s ease-out",
              "@keyframes fadeIn": {
                from: { opacity: 0, transform: "translateY(-20px)" },
                to: { opacity: 1, transform: "translateY(0)" },
              },
            }}
          >
            <IconButton
              onClick={handleCloseCreateItemModal}
              sx={{
                position: "absolute",
                top: 12,
                right: 12,
                zIndex: 10,
                color: "grey.500",
                backgroundColor: "rgba(0,0,0,0.05)",
                "&:hover": {
                  backgroundColor: "rgba(0,0,0,0.1)",
                },
                transition: "background-color 0.2s",
              }}
            >
              <CloseIcon />
            </IconButton>

            {openCreateItemModal && (
              <Box
                sx={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  overflow: "auto",
                  p: 2,
                }}
              >
                <CreateItemComponent />
              </Box>
            )}
          </Box>
        </Modal>

        {/* Modal de edición de ítems - Ahora usa CreateItemComponent unificado */}
        <Modal
          open={openModal}
          onClose={handleCloseModal}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
          closeAfterTransition
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              width: { xs: "95%", sm: "90%", md: "85%", lg: "80%" },
              maxWidth: "1200px",
              height: "90vh",
              bgcolor: "background.paper",
              boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
              borderRadius: "12px",
              overflow: "auto",
              display: "flex",
              flexDirection: "column",
              position: "relative",
              animation: "fadeIn 0.3s ease-out",
              "@keyframes fadeIn": {
                from: { opacity: 0, transform: "translateY(-20px)" },
                to: { opacity: 1, transform: "translateY(0)" },
              },
            }}
          >
            {openModal && (
              <CreateItemComponent onClose={handleCloseModal} selectedItem={itemEditable} />
            )}
          </Box>
        </Modal>

        <Modal
          open={openCompraModal}
          onClose={handleCloseCompraModal}
          aria-labelledby="compra-modal-title"
          aria-describedby="compra-modal-description"
          closeAfterTransition
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            p: 1,
          }}
        >
          <Box
            sx={{
              width: "95vw",
              height: "90vh",
              bgcolor: "background.paper",
              borderRadius: 2,
              boxShadow: 24,
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                p: 2,
                borderBottom: "1px solid rgba(0,0,0,0.12)",
                backgroundColor: alpha(theme.palette.primary.main, 0.1),
              }}
            >
              <Typography variant="h6" component="h2" sx={{ fontWeight: 600 }}>
                Generar Compra - {selectedItems.length} items seleccionados
              </Typography>
              <IconButton onClick={handleCloseCompraModal} size="small">
                <CloseIcon />
              </IconButton>
            </Box>

            <Box sx={{ flex: 1, overflow: "auto", p: 2 }}>
              {compraData && (
                <GestionGenerarCompraComponent
                  preloadedData={compraData}
                  onClose={handleCloseCompraModal}
                  isModal={true}
                />
              )}
            </Box>
          </Box>
        </Modal>
        {/* START UPDATE */}
        <Modal
          open={openConfirmDeleteModal}
          onClose={() => setOpenConfirmDeleteModal(false)}
          aria-labelledby="confirm-delete-modal-title"
          aria-describedby="confirm-delete-modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 4,
              borderRadius: 2,
              minWidth: { xs: "90%", sm: 500 },
              maxWidth: 600,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
              <WarningIcon color="error" sx={{ fontSize: 48 }} />
              <Typography id="confirm-delete-modal-title" variant="h6" component="h2" sx={{ fontWeight: 700 }}>
                ⚠️ Confirmar Eliminación
              </Typography>
            </Box>

            <Divider sx={{ mb: 2 }} />

            <Typography id="confirm-delete-modal-description" variant="body1" sx={{ mb: 2 }}>
              Está a punto de eliminar{" "}
              <strong style={{ color: theme.palette.error.main }}>{itemsSeleccionadosParaEliminar.length}</strong>{" "}
              item(s).
            </Typography>

            <Box
              sx={{
                p: 2,
                mb: 3,
                backgroundColor: alpha(theme.palette.error.main, 0.05),
                borderRadius: 1,
                border: `1px solid ${alpha(theme.palette.error.main, 0.2)}`,
              }}
            >
              <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 600 }}>
                {hayFiltroUbicacion
                  ? `📍 Se eliminará la ubicación de estos items, no el item completo.`
                  : "🗑️ Se eliminarán estos items y TODAS sus ubicaciones de forma permanente (soft delete)."}
              </Typography>
            </Box>

            <Typography variant="body2" color="error" sx={{ mb: 3, fontStyle: "italic" }}>
              Esta acción no se puede deshacer fácilmente.
            </Typography>

            <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end" }}>
              <Button
                variant="outlined"
                onClick={() => setOpenConfirmDeleteModal(false)}
                sx={{ textTransform: "none" }}
              >
                Cancelar
              </Button>

              <Button
                variant="contained"
                color="error"
                onClick={handleConfirmDelete}
                startIcon={<DeleteIcon />}
                sx={{
                  textTransform: "none",
                  fontWeight: 600,
                }}
              >
                Confirmar Eliminación
              </Button>
            </Box>
          </Box>
        </Modal>
        {/* END UPDATE */}
      </Box>
    </>
  )
}
